import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInUser, getFrontendErrorMessage } from "../../utils/fireStoreFunction";
import "../../style/authentication.css"; // Corrected path

export default function LoginForm() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleUser = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await signInUser(email, password);
        if (res.success) {
            navigate("/");
        } else {
            const errorMsg = getFrontendErrorMessage(res.error);
            setErrorMessage(errorMsg);
        }
        setLoading(false);
    };

    return (
        <form onSubmit={handleUser}>
            <div className="form-group">
                <input
                    type="email"
                    id="input_form"
                    placeholder="Your Email"
                    autoComplete="off"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <i className="input-icon material-icons">alternate_email</i>
            </div>
            <div className="form-group">
                <input
                    type="password"
                    id="input_form"
                    placeholder="Your Password"
                    autoComplete="off"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <i className="input-icon material-icons">lock</i>
            </div>
            {errorMessage && <p className="handle_text">{errorMessage}</p>}
            <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? "Logging In..." : "Submit"}
            </button>
        </form>
    );
}